export default {
  setHomeSettings(state, settings) {
    state.homeSettings = settings
  },
  setHomeCity(state, city) {
    state.homeCity = city
  },
  setLocateCity(state, city) {
    state.locateCity = city
  },
  setIsLocating(state, flag) {
    state.locating = flag
  }
  // setNProduct(state, product) {
  //     state.nproduct = product
  // },
}
